export const getIdentifier = (entity) => entity.id !== undefined ? entity.id : entity.temporaryId;